import { render } from "./CadastrarAssinatura.vue?vue&type=template&id=28d5f1de&scoped=true"
import script from "./CadastrarAssinatura.vue?vue&type=script&lang=js"
export * from "./CadastrarAssinatura.vue?vue&type=script&lang=js"

import "./CadastrarAssinatura.vue?vue&type=style&index=0&id=28d5f1de&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d5f1de"]])

export default __exports__